import type { FC } from 'react';
import type { TasksSectionProps } from './TasksSection.types';

import * as uiLib from '@compliance.ai/web-components';
import * as constants from './TasksSection.constants';

import { useTasksSectionData } from './hooks';

export const TasksSection: FC<TasksSectionProps> = ({ documentTasks, classNames }) => {
  const { formattedData } = useTasksSectionData({
    documentTasks
  });

  return (
    <uiLib.Table
      rowKey={constants.TABLE_FIELDS.ID}
      shouldRenderToolbar={false}
      columns={constants.TABLE_COLUMNS}
      rows={formattedData.rows}
      classNames={{
        container: classNames?.tableOuterContainer,
        headerCell: classNames?.headerCell,
        cell: classNames?.cell,
        tableContainer: classNames?.tableContainer
      }}
    />
  );
};
